import FrontEndApiService from './frontend.api.service';
import {runAsPublic} from "@helpers/api-helper";
import axios from 'axios';
const StripeService = {
    async sendPayment({token, email, planName, amount}, isPublic = false) {
        return await runAsPublic(async (config) => {
            return await FrontEndApiService.post(`${config.apiPrefix}/${config.apiVersion}/stripe/send-payment/`, {
                stripeToken: token,
                email: email,
                planName: planName,
                amount: amount,
            });
        });
    },
    async getSubscriptionPackages(productId){
        return await axios.get(`${window.env.MILESTONES_API_HOST}/api/v1/stripe/subscription/prices/${productId}`);
    },
    async createPaymentIntent(){
        return await axios.get(`${window.env.MILESTONES_API_HOST}/api/v1/stripe/payment-intent`);
    },
    async createSubscription(planId, paymentMethod){
        await this.addPaymentMethod(paymentMethod)
        return await axios.post(`${window.env.MILESTONES_API_HOST}/api/v1/stripe/subscription`,{
            price_id: planId,
            payment_method: paymentMethod
        }); 
    },
    async addPaymentMethod(paymentMethod){
        await axios.post(`${window.env.MILESTONES_API_HOST}/api/v1/stripe/payment-method`,{
            payment_method: paymentMethod
        });          
    }
};

export default StripeService;
